import { render, staticRenderFns } from "./ResearchOptions.vue?vue&type=template&id=db578a16&scoped=true&"
import script from "./ResearchOptions.vue?vue&type=script&lang=js&"
export * from "./ResearchOptions.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOptions.vue?vue&type=style&index=0&id=db578a16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db578a16",
  null
  
)

export default component.exports